import * as React from 'react';

function SvgIn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M19 2a3 3 0 012.995 2.824L22 5v14a3 3 0 01-2.824 2.995L19 22h-4a1 1 0 01-.117-1.993L15 20h4a1 1 0 00.993-.883L20 19V5a1 1 0 00-.883-.993L19 4h-4a1 1 0 01-.117-1.993L15 2h4zm-8.387 4.21l.094.083 5 5a.97.97 0 01.08.09l-.08-.09a1.008 1.008 0 01.292.675L16 12v.033l-.004.052L16 12a1.008 1.008 0 01-.22.625l-.073.082-5 5a1 1 0 01-1.497-1.32l.083-.094L12.585 13H3a1 1 0 01-.117-1.993L3 11h9.585L9.293 7.707a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083z" />
    </svg>
  );
}

export default SvgIn;
